(function () {
  if (!window.retextion) {
    window.retextion = {};
  }

  window.retextion.product = function (options) {
    var formSelector = options.formSelector;
    var sellingPlanGroupsSelector = options.sellingPlanGroupsSelector;
    var sellingPlanIdInputSelector = options.sellingPlanIdInputSelector;
    var priceContainerSelector = options.priceContainerSelector;
    var regularPriceSelector = options.regularPriceSelector;
    var salePriceSelector = options.salePriceSelector;
    var variantSelectorSelector = options.variantSelectorSelector;

    var product = options.product;
    var groupToSellingPlans = options.groupToSellingPlans;
    var variantToPrice = options.variantToPrice;
    var variantToSellingPlanAllocations =
      options.variantToSellingPlanAllocations;
    var priceDisplayMode = options.priceDisplayMode || "strike";
    var showSubscriptionDiscountBadge = !!options.showSubscriptionDiscountBadge;

    var $form;
    var $sellingPlanIdInput;

    var variantsHandler;
    var priceDisplayHandler;
    var sellingPlanGroupsHandler;
    var quantityHandler;

    function initialize() {
      $form = document.querySelector(formSelector);
      $sellingPlanIdInput = document.querySelectorAll(
        sellingPlanIdInputSelector
      );

      const $variantIdInput = document.querySelector('input[name="id"]');
      const $variantSelector = document.querySelector('#productSelect');

      // Show only the selling plan groups + plans available for the given variant
      function filterPlansForVariant(variantId, syncSelection) {
        const allocations = variantToSellingPlanAllocations[variantId] || [];
        const allocatedPlanIds = allocations.map((a) => String(a.sellingPlanId));
        const allocatedGroupIds = allocations.map((a) => a.sellingPlanGroupId);

        // Update one-time price if the element exists
        const variantPrice = variantToPrice[variantId];
        const onetimePriceSelector = document.querySelector(
          'label[for="product_onetime"] .rtx_option_subheading'
        );
        if (onetimePriceSelector && variantPrice) {
          onetimePriceSelector.textContent = variantPrice.priceFormatted;
        }

        // Groups: show only those the variant has allocations for
        document.querySelectorAll(".rtx_option--sub").forEach((groupEl) => {
          const groupId = groupEl.getAttribute("data-group-id");
          if (allocatedGroupIds.indexOf(groupId) !== -1) {
            showElement(groupEl);
            const priceEl = groupEl.querySelector(".rtx_option_subheading");
            if (priceEl) {
              const alloc = allocations.find(
                (a) => a.sellingPlanGroupId === groupId
              );
              if (alloc) priceEl.textContent = alloc.priceFormatted;
            }
          } else {
            hideElement(groupEl);
          }
        });

        // Dropdown options: show only plans the variant has allocations for
        document
          .querySelectorAll(".rtx_option_plans_dropdown")
          .forEach((dropdown) => {
            let needsReselect = false;
            Array.from(dropdown.options).forEach((option) => {
              const available =
                allocatedPlanIds.indexOf(String(option.value)) !== -1;
              option.hidden = !available;
              option.disabled = !available;
              if (!available && option.selected) needsReselect = true;
            });
            if (needsReselect) {
              const firstAvailable = Array.from(dropdown.options).find(
                (o) => !o.disabled
              );
              if (firstAvailable) dropdown.value = firstAvailable.value;
            }
          });

        // If the currently selected option is now hidden, fall back to the
        // first visible option; otherwise re-sync the selling plan input
        if (syncSelection) {
          const checked = document.querySelector(
            'input[name="selling_plan_select"]:checked'
          );
          const checkedOption = checked && checked.closest(".rtx_option");
          if (!checkedOption || checkedOption.classList.contains("hide")) {
            const fallback = document.querySelector(
              '.rtx_option:not(.hide) input[name="selling_plan_select"]'
            );
            if (fallback) fallback.click();
          } else {
            setSellingPlan();
          }
        }
      }

      if ($variantSelector) {
        $variantSelector.addEventListener("change", function (e) {
          filterPlansForVariant(e.target.value, true);
        });
      }

      // Filter on load for the initially selected variant (no selection sync —
      // Liquid already renders the correct initial state)
      if ($variantIdInput && $variantIdInput.value) {
        filterPlansForVariant($variantIdInput.value, false);
      }

      var productForm = document.querySelector(formSelector);
      var variantSelector = document.querySelector('.pdp-variant-selector')
      var rtxnParentBlock = document.querySelector(".rtxn-block");
      if (productForm && rtxnParentBlock && variantSelector) {
        var fragment = document.createDocumentFragment();
        fragment.appendChild(rtxnParentBlock);
        variantSelector.parentNode.insertBefore(fragment, variantSelector.nextSibling);
        // productForm.prepend(fragment);
      }

      // Utility function to easily update the selected selling plan and related elements
      function setSellingPlan() {
        var selectedVariant = document.querySelector('input[name="id"]').value;
        var selectedOption = document.querySelector(
          'input[name="selling_plan_select"]:checked'
        );
        document.querySelector('input[name="selling_plan"]').value = "";
        if (selectedOption.value === "onetime") {
          document.querySelector('input[name="selling_plan"]').value = "";
          document.querySelectorAll(".rtx_option_plans").forEach((plans) => {
            plans.style.display = "none";
          });
          document.querySelectorAll(
            `.js-atc-sub-price`
          ).forEach((el) => el.style.display = 'none');
          document.querySelectorAll(
            `.js-atc-sub-compare-at-price`
          ).forEach((el) => el.style.display = 'none');
          document.querySelectorAll(
            `.js-atc-onetime-price`
          ).forEach((el) => el.style.display = 'block');
          document.querySelectorAll(".js-current-plan").forEach((plans) => {
              plans.innerHTML = "ONE TIME PURCHASE";
          });
        } else {
          // Prefer the dropdown belonging to the active (checked) group
          var activeGroupId = selectedOption
            .closest(".rtx_option")
            .getAttribute("data-group-id");
          var sellingPlanDropdown = document.querySelector(
            `.rtx_option_plans_dropdown[data-group-id="${activeGroupId}"]`
          );
          if (!sellingPlanDropdown) {
            document
              .querySelectorAll(".rtx_option_plans_dropdown")
              .forEach((dropdown) => {
                if (!dropdown.classList.contains("hide")) {
                  sellingPlanDropdown = dropdown;
                }
              });
          }
          if (!sellingPlanDropdown) return;
          var sellingPlanId = sellingPlanDropdown.value;
          const variantAllocation = (
            variantToSellingPlanAllocations[selectedVariant] || []
          ).find((alloc) => alloc.sellingPlanId == sellingPlanId);
          if (!variantAllocation) return;
          // Sets the sub price 
          // document.querySelector(
          //   `.rtx_option--sub[data-group-id="${variantAllocation.sellingPlanGroupId}"] .rtx_option_subheading`
          // ).textContent = variantAllocation.priceFormatted;
          document.querySelectorAll(
              `.js-atc-onetime-price`
          ).forEach((el) => el.style.display = 'none');
          document.querySelectorAll(
              `.js-atc-sub-price`
          ).forEach((el) => el.style.display = 'block');
          document.querySelectorAll(
              `.js-atc-sub-compare-at-price`
          ).forEach((el) => el.style.display = 'block');
          document.querySelectorAll(
              `.js-atc-sub-price`
          ).forEach((el) => el.textContent = variantAllocation.priceFormatted);
          document.querySelector('input[name="selling_plan"]').value =
              sellingPlanId;
          document.querySelectorAll(".rtx_option_plans").forEach((plans) => {
            plans.style.display = "block";
          });
          document.querySelectorAll(".js-current-plan").forEach((plans) => {
            if (sellingPlanDropdown != null) {
              plans.innerHTML = sellingPlanDropdown.options[sellingPlanDropdown.selectedIndex].text;
            }
          });

        }

      }
      document
        .querySelectorAll(".rtx_option_plans_dropdown")
        .forEach((dropdown) => {
          dropdown.addEventListener("change", function (e) {
            setSellingPlan();
          });
        });

      document
        .querySelectorAll('input[name="selling_plan_select"]')
        .forEach((rbi) => {
          rbi.addEventListener("change", function (e) {
            var selected = document.querySelector(
              'input[name="selling_plan_select"]:checked'
            );
            var sellingPlanGroupId = selected
              .closest(".rtx_option")
              .getAttribute("data-group-id");
            document.querySelectorAll(".rtx_option").forEach((option) => {
              option.classList.remove("option--active");
            });
            selected.closest(".rtx_option").classList.add("option--active");

            if (selected.value === "onetime") {
              document
                .querySelectorAll(".rtx_option_plans")
                .forEach((plans) => {
                  plans.style.display = "none";
                });

            } else {
              document
                .querySelectorAll(".rtx_option_plans")
                .forEach((plans) => {
                  plans.style.display = "block";
                });
              document
                .querySelectorAll(".rtx_option_plans select")
                .forEach((select) => hideElement(select));
              showElement(
                document.querySelector(
                  `.rtx_option_plans select[data-group-id="${sellingPlanGroupId}"]`
                )
              );
            }
            setSellingPlan();
          });
        });
    }

    // Utility Functions
    const showElement = (element) => {
      return element.classList.remove("hide");
    };

    const hideElement = (element) => {
      if (
        typeof element !== "undefined" &&
        !element.classList.contains("hide")
      ) {
        return element.classList.add("hide");
      }
    };

    // Init
    initialize();
  };
})();
